var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('img',{ref:"image",style:(_vm.imageStyle),attrs:{"src":_vm.imageSource}})])
}
var staticRenderFns = []

export { render, staticRenderFns }